export var iFrameParams;
(function (iFrameParams) {
    iFrameParams["TIERS_KEY"] = "current-tiers-ref";
})(iFrameParams || (iFrameParams = {}));
//# sourceMappingURL=iframe-params.js.map